import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import dayjs from 'dayjs'

import { api } from '../adminApi'
import { GetStoreUploadResponse } from '../generated/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreUpload',
  props: {
    store: null,
    upload: null
  },
  setup(__props: any) {

const props = __props as {
  store: string,
  upload: string,
}




const headers = [
  {
    text: "File Name",
    value: "fileName",
  },
  {
    text: "Blob Identifier",
    value: "blobIdentifier",
  },
  {
    text: "Status",
    value: "status",
  }
]

const storeUpload = ref(null as (null | GetStoreUploadResponse))

function timestampToDisplayString(timestamp: string): string {
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm')
}

async function fetch() {

  try {
    const storeUploadResponse = await api.getStoreUpload(props.upload as unknown as number, props.store)
    storeUpload.value = storeUploadResponse.data
  } catch (error) {
    console.log(error)
  }
}

fetch()


return { __sfc: true,props, headers, storeUpload, timestampToDisplayString, fetch }
}

})